import React from 'react';
import { classNames } from '../../utils/style';
import { FaqElement, QuestionAnswerProps } from './FaqElement';

export interface FaqProps {
  body: QuestionAnswerProps[];
  className?: string;
  classNameElement?: string;
}

export const Faq = ({ body, className }: FaqProps) => {
  return (
    <div
      className={classNames(
        'Faq',
        'w-full',
        'border-y border-x-0 border-[#DFE6ED]',
        className,
      )}
    >
      {body.map(({ btnProps, ...item }: any, index: number) => (
        <FaqElement
          key={index}
          item={item}
          index={index}
          onClick={item?.onClick}
          btnProps={btnProps}
        />
      ))}
    </div>
  );
};
